export default function Contact(){
    return(
        <div className='text-center mt-20 text-white font-Londrina flex flex-col items-center md:px-60'>
            <div className="text-9xl outlined-text">CONTACT</div>
            <div className="mt-5 space-x-5 flex flex-row items-center">
                <div className="text-3xl outlined-text ">benjaminduffield1997@gmail.com</div>
                <div className="text-2xl">for your crypto token website.</div>
            </div>
            <div className="mt-40  text-9xl outlined-text">BASED PEPE</div>
            <div className="text-white mt-5 mb-20 text-2xl font-bold">DISCLAIMER: BASED PEPE is a meme coin with no intrinsic value or expectation of financial return.</div>
        </div>
    )
}